import { render, staticRenderFns } from "./WizardStepConfig.vue?vue&type=template&id=7b9d829a&scoped=true"
import script from "./WizardStepConfig.vue?vue&type=script&lang=js"
export * from "./WizardStepConfig.vue?vue&type=script&lang=js"
import style0 from "./WizardStepConfig.vue?vue&type=style&index=0&id=7b9d829a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9d829a",
  null
  
)

export default component.exports